import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import inseminationListAction from './inseminationList.action.json' with { type: 'json' }
import { inseminationObject } from '../inseminationObject'
import { inseminatorExpression } from '../../inseminator/list/inseminatorList.definition'
import { semenProgramExpression } from '../../semenProgram/list/semenProgramList.definition'

export const inseminationExpression = expression(inseminationObject.shape)

const inseminationListDefinition = defineAction({
  ...inseminationListAction,

  input: z.object({
    filter: inseminationExpression.nullish(),
    inseminatorFilter: inseminatorExpression.nullish(),
    semenProgramFilter: semenProgramExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      earringNumber: 'Brinco',
      citizenId: 'Cidadão',
      programId: 'Programa',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(inseminationObject),
    count: z.number(),
  }),
})

export default inseminationListDefinition
